import { useEffect } from 'react';
import initCarousel from '../../../components/carousels/carousel';
import classNames from 'classnames';
import Skeleton from '@mui/material/Skeleton';
import { CarouselSkipLink } from '../../../components/CarouselSkipLink';

const LocalCarsPlaceholderCarousel = () => {
    const ariaLabel = 'Shop cars near me';
    const name = 'local-cars-placeholder';
    const nextFocus = 'online-offer';

    useEffect(() => {
        initCarousel({
            nextFocus: nextFocus,
            container: `#${name}-carousel-slides`,
            autoWidth: true,
            prevFocus: `#pre-${name}-carousel`,
            gutter: 12,
            slideBy: 'page',
            items: 4,
            responsive: {
                [900]: {
                    gutter: 16,
                },
                0: {},
            },
        });
    }, []);

    return (
        <>
            <CarouselSkipLink
                id={`pre-${name}-carousel`}
                href={nextFocus}
                text={`Skip ${ariaLabel ? ariaLabel : name.replace(/-/g, ' ')} Carousel`}
            />
            <div className={classNames('carousel max-width--xl')}>
                <div id={`${name}-carousel-slides`} data-carousel-length={6} className={classNames('carousel__slides')}>
                    <div className="carousel__slide" key={`0-slide`}>
                        <Skeleton key={`0-lc-placeholder`} variant="rounded" height={367} width={270} />
                    </div>
                    <div className="carousel__slide" key={`1-slide`}>
                        <Skeleton key={`1-lc-placeholder`} variant="rounded" height={367} width={270} />
                    </div>
                    <div className="carousel__slide" key={`2-slide`}>
                        <Skeleton key={`2-lc-placeholder`} variant="rounded" height={367} width={270} />
                    </div>
                    <div className="carousel__slide" key={`3-slide`}>
                        <Skeleton key={`3-lc-placeholder`} variant="rounded" height={367} width={270} />
                    </div>
                    <div className="carousel__slide" key={`4-slide`}>
                        <Skeleton key={`4-lc-placeholder`} variant="rounded" height={367} width={270} />
                    </div>
                    <div className="carousel__slide" key={`5-slide`}>
                        <Skeleton key={`5-lc-placeholder`} variant="rounded" height={367} width={270} />
                    </div>
                </div>
            </div>
        </>
    );
};

export default LocalCarsPlaceholderCarousel;
